import React, { useState, useEffect } from 'react';
import Menu from '../components/menu';
import Footer from '../components/footer';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';


export default function Realization() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [realization, setRealization] = useState(null);
    const [allIds, setAllIds] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get('https://megamont.pl/api/realizations');
                const data = res.data;
                setAllIds(data.map(r => r.id));
                const current = data.find(r => String(r.id) === String(id));
                setRealization(current);
            } catch (error) {
                console.error("Błąd ładowania danych:", error);
            }
        };
        fetchData();
    }, [id]);

    if (!realization) return null;

    const images = JSON.parse(realization.images || "[]");
    const currentIndex = allIds.indexOf(Number(id));
    const nextId = currentIndex > 0 ? allIds[currentIndex - 1] : null;
    const prevId = currentIndex !== -1 && currentIndex < allIds.length - 1 ? allIds[currentIndex + 1] : null;

    return (
    <main className='MainPage'>
        <Menu/>
        <div className="Realization">
            <div className="Content">
                <div className="Cont">
                    <div className="Images">
                        {/* DODANO KEY={id} - to wymusza przeładowanie karuzeli przy zmianie projektu */}
                        <div 
                            key={id} 
                            id="carouselExampleIndicators" 
                            className="carousel slide" 
                            data-bs-ride="carousel"
                        >
                            <div className="carousel-indicators">
                                {images.map((_, index) => (
                                    <button 
                                        key={index}
                                        type="button" 
                                        data-bs-target="#carouselExampleIndicators" 
                                        data-bs-slide-to={index} 
                                        className={index === 0 ? "active" : ""} 
                                        aria-current={index === 0 ? "true" : "false"} 
                                        aria-label={`Slide ${index + 1}`}
                                    ></button>
                                ))}
                            </div>
                            <div className="carousel-inner" style={{height: "79.3vh"}}>
                                {images.map((img, index) => (
                                    <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`} style={{height: "100%"}}>
                                        <div 
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                backgroundImage: `url(https://megamont.pl/uploads/realizacja_${realization.id}/${img})`,
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                                backgroundRepeat: "no-repeat",
                                                backgroundColor: "#222" // Kolor tła zanim załaduje się zdjęcie
                                            }}
                                            aria-label={realization.name}
                                        ></div>
                                    </div>
                                ))}
                            </div>
                            {images.length > 1 && (
                                <>
                                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="Info" style={{minWidth:"17vw"}}>
                        <div className="Title">{realization.name}</div>
                        <div className="Description">
                            <p style={{ whiteSpace: 'pre-wrap' }}>{realization.description}</p>
                        </div>
                        <div className="Pagination">
                            <span>Realizacja</span>
                            <div className="Pag">
                                {prevId && (
                                    <div className="Prev btn-custom" onClick={() => navigate(`/realization/${prevId}`)} style={{cursor:'pointer'}}>
                                        Poprzednia
                                    </div>
                                )}
                                {nextId && (
                                    <div className="Next btn-custom" onClick={() => navigate(`/realization/${nextId}`)} style={{cursor:'pointer'}}>
                                        Następna
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </main>
    );
}